/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cropaspectlandscape2Inputs */

const en_cropaspectlandscape2 = /** @type {(inputs: Cropaspectlandscape2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`16:9`)
};

const de_cropaspectlandscape2 = /** @type {(inputs: Cropaspectlandscape2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`16:9`)
};

/**
* | output |
* | --- |
* | "16:9" |
*
* @param {Cropaspectlandscape2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const cropaspectlandscape2 = /** @type {((inputs?: Cropaspectlandscape2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cropaspectlandscape2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cropaspectlandscape2(inputs)
	return de_cropaspectlandscape2(inputs)
});
export { cropaspectlandscape2 as "cropAspectLandscape" }